export const offer = {
  offerPrice: {
    firstTimePurchaseIncludes: 'First time purchase includes:',
    free: 'Free',
    total: 'Total',
    valueOfOneTimePurchase: 'Value of one-time purchase',
    firstMonthFree: 'Get a free month of AG1 + a free Welcome Kit**',
    firstMonthFreeTag: 'Free First Month'
  }
};
